module.exports = __webpack_public_path__ + "asset/image-calendar-screenshot-3ef1f87618adfd16.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/scene/landing/image/calendar-screenshot.png
// module id = X2Q6
// module chunks = 1